import React from "react";
import AsyncSelect from "react-select/async";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const selectMenuStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 10,
  }),
};

const SearchSelect = ({
  defaultOpts,
  loadOpts,
  field,
  onSelChange,
  isDisabled,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <AsyncSelect
        {...field}
        cacheOptions
        isClearable={true}
        defaultOptions={defaultOpts}
        placeholder={t("inputs.select")}
        getOptionLabel={(e) => e.label}
        getOptionValue={(e) => e.value}
        loadOptions={(inputValue) => loadOpts(inputValue)}
        onChange={(value) => onSelChange(value)}
        isDisabled={isDisabled}
        styles={selectMenuStyles}
      />
    </>
  );
};

SearchSelect.propTypes = {
  defaultOpts: PropTypes.array.isRequired,
  loadOpts: PropTypes.func.isRequired,
};

SearchSelect.defaultProps = {
  onSelChange: () => {},
  isDisabled: false,
};

export default SearchSelect;
